module.exports = __webpack_public_path__ + "static/media/TN-Women-Outerwears-2.0.b6be04ee.svg";